export const environment = {
  production: false,
  title: 'Nishwik',
  apiURL: 'https://dev.apig.nishwik.com',
  plApiURL: 'https://dev.apig.invest.nishwik.com',
  hmApiURL: 'https://dev.apig.h.nishwik.com',
  smApiURL: 'https://dev.apig.sm.nishwik.com',
  speApiURL: 'https://dev.apig.spe.nishwik.com',
  invApiURL: 'https://dev.apig.inv.nishwik.com',
   crmApiURL: 'https://dev.apig.nishwik.com',
  // websiteURL: 'http://localhost:4200',
  websiteURL: 'https://dev.nishwik.com',

  olaAPI: 'GR2Tnz2lbgTJUvFo1zS7cVrUjhBfAjqd9LaoPB9t',
  sandBoxAPI: '',
  razorPayAPIKeyId: 'rzp_test_TRCOwq6GKFtMEy',
  alertConfigId: 1,

  erpURL: 'https://dev.apig.vnccy.com',
  erpRedirectURL: 'https://dev.advinsoftwares.com/login?companyId=0',

  nishwikCompanyId: 5225,
  nishwikBranchId: 3067,

  digioSdkUrl: 'https://app.digio.in/sdk/v11/digio.js',

  hospitalExternalApiKey: "client-hospital-01",
  schoolExternalApiKey: "client-school-01",
  societyExternalApiKey: "client-society-01",
  crmExternalApiKey: "client-crm-01",
  masterExternalApiKey: "client-master-01",

  privateKeyPem: "-----BEGIN RSA PRIVATE KEY-----\nMIIEpQIBAAKCAQEAxp4+IrLBF3C38tYC3rjMLFGMeboqdXm+k1i4WomXZ6AsxfGm\nH1e2wmdKiMi1CLnUFl3QwaVDgOVNppVhvol+CMcHE1IJe7sXm4S8DLT6VMl0lyib\nGgy3/gMRpKR1zN894T+Ir0ySb81fLBYlaby0Vg1C4eULlISlNjGn2VCXpa1VU2Vr\noAbTCzQ2WGuAWvic9WFsu2KCUEAiTqhA7782/TJvjkjgjcz+fZBwpu8n4F30ZKA6\nz1xB5VV8ntiw46w1D6SLJK7YqC53YfbKtRsumy9L4+ogkvT75bI+Ope+dkDnvFsu\nLbODiP4sH5iDGtAWjMdVVWcj0NpC8cEvNc1j+QIDAQABAoIBAQCxqhVMtndQv2xc\nFSGmFsnUDvJIZMXcJZXaee8WVaOQd0/1lG4T9UMu7HRYnKiLcKaNh0fYIDuczgDC\ntTck2BpcQaRLnQOMoVPBsl8AQtb2Bup62EC9cYkX96jNjKsvIrZYiZt7q1QGHEA4\n0GqRBdKOcvhT1q2gIXMjYhGRq6yq7ih8HwpwLy3dY9KaZm3O1Oq9Riz2TI/YH4zB\nteleFEQHUN07va2URuaGdU6+g9ASgP5G7qDeTS28jgDcckyndl97QQnHFrOIAIxw\nqJehmF+yT30luCUre2175DYemCByfPAjeFOES1xCQnFOwC4V8lQNnEa38U3+PXuc\nYo/IHzqdAoGBAPBd6Ry1GUTPs4OzdyRHCW50zOLp/kDtGwF+M/W6wbzJH+blFUx4\nENsY0HiNjUJI7II5KCFkQEuC23ebPdhBCCwS00DpZawrLvYE3pKhDD1sUZfXob7F\nLD1V5jXviZTR/EozNSu4XwNEELkXJP2gHDGRN5WO5CAT2XpU12YmIUJLAoGBANOJ\nOCx1JV07xT2STsrppYXbTF2j865KQsMsik6RzRrZktFFWUAMeZrwm+A9P+TJZC0L\n8wlo4cTmeKajqwQxEi5sEgiFwbJ4Uz0K9StN7Ii92sRKuTxpbRaDhwJj1zfjXQ3Z\nq/13990mdOqbM+WGKNyM668KYt2pOS2jF3QdEehLAoGBAOoHdY2m4eh2leEYHltq\n8srh3A7fJteOQ+oLN4n8gN9Pr8j+qOMgT8ETAv8tSykLmYMdJW6Fjng2+3oT434n\nq05GMfuUg5LDJOESUqbPOPyg9zxxDaGRloZNmWxQQlNstEiGXTGpPJEQd3vPBgwP\nFQRJ0KXET2bQDMIn0uU5IM7LAoGAberRe5hrj+Ss+u95bcq2rbVkGwxEZP5FbrFI\nNMdiMl94ALHuTG+vCKmZ9Y0eFD3phda9tNgA6JVxf/Vvub/d2K1jOXZ3TctkRUXa\nW2QkUnGEqZbCZffKLXauwrkqbeoAwl+nFRAvhYSkH/wBnXR26xN2q//Tm6aBBYvH\ndhhc470CgYEApgMgBpZERuhwOKuWnMTXp/MuzL+Eafnb3Qpc1xulRs5RHcTMzehp\nGxZ+ajTn1Gkou+j2NEJgnlPtp7hKO/WidS5B0tYv6ChHNeXJwbubwly5VHQ8dQqn\nNwAnxfxlFfHpFFjorgq/KS7IP3ji+0XKNlWh1MzZaKS6zvAbAglET98=\n-----END RSA PRIVATE KEY-----",


  digilockerSuccessWebhookUrl:
    "https://dev.nishwik.com/paylater/quickloan-process",

  digilockerFailureWebhookUrl:
    "https://dev.nishwik.com/paylater/quickloan-process"
};


// ======================================================
// ROLE IDS
// Use these Role IDs everywhere instead of hardcoding.
// ======================================================

export const roleIds = {

  // =========================
  // BACK OFFICE
  // =========================
  backOfficeAdmin: 1,


  // =========================
  // SCHOOL ROLES
  // =========================
  schoolAdmin: 5,
  parent: 6,
  speAdministrator: 12,
  student: 16,
  teacher: 17,
  nonTeachingStaff: 18,
  driver: 19,
  schoolOwner: 25,


  // =========================
  // SOCIETY ROLES
  // =========================
  societyAdmin: 7,
  societyFlatMember: 8,
  societySecurityStaff: 21,
  societyCommittee: 28,

  legacySocietyDashboardRole: 20,


  // =========================
  // HOSPITAL ROLES
  // =========================

  // RoleId 9
  hospitalAdmin: 9,

  // RoleId 10
  hospitalUser: 10,

  // RoleId 20
  hospitalNurse: 20,

  // RoleId 22
  hospitalDoctor: 22,

  // RoleId 29
  hospitalReceptionist: 29,

  // RoleId 32
  hospitalOwner: 32,

  // RoleId 35 - HM_Other_Staff
  hospitalOtherStaff: 35,

} as const;